import React from 'react';
import {Bar, BarChart, CartesianGrid, ResponsiveContainer, Tooltip, XAxis, YAxis} from 'recharts';

const STATUSES = ['NEW', 'PENDING_FULFILLMENT', 'FULFILLED', 'CANCELLED'];

export default function OrdersPipeline({ orders = [] }) {
  const data = STATUSES.map(status => ({
    stage: status.replace(/_/g, ' '),
    count: orders.filter(o => o.status === status).length,
  })).filter(d => d.count > 0);

  return (
    <div className="bg-white rounded-lg shadow p-6">
      <h2 className="text-lg font-semibold text-gray-900 mb-4">Orders by Status</h2>
      {data.length === 0 ? (
        <p className="text-gray-500 text-center py-12">No orders yet.</p>
      ) : (
        <ResponsiveContainer width="100%" height={300}>
          <BarChart data={data}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="stage" />
            <YAxis allowDecimals={false} />
            <Tooltip />
            <Bar dataKey="count" fill="#dc2626" />
          </BarChart>
        </ResponsiveContainer>
      )}
    </div>
  );
}
